import requester from '@/lib/axios';
import { OrderingFrom } from '@/models/Filter';
import JsonApiResponse from '@/models/JsonApiResponse';
import { BaseFilters } from '@/models/Service';
import StudentExam, {
  StudentExamCorrectionDTO,
  StudentExamCorrectionStatusEnum,
} from '@/models/StudentExam';
import { StudentExamActivityProgress } from '@/models/StudentExamActivityProgress';
import { StudentExamCorrection } from '@/models/StudentExamCorrection';

export const STUDENT_EXAM_ORDERING_FIELDS = ['finished_at'] as const;

export type StudentExamOrdering = OrderingFrom<
  typeof STUDENT_EXAM_ORDERING_FIELDS
>;

export interface StudentExamFilterParams extends BaseFilters {
  pageNumber?: number;
  pageSize?: number;
  klassId?: number[];
  examId?: number[];
  studentId?: number[];
  teacherId?: number[];
  unitId?: number[];
  courseId?: number[];
  finishedAtAfter?: string;
  finishedAtBefore?: string;
  status?: StudentExamCorrectionStatusEnum[];
  ordering?: StudentExamOrdering;
}

export interface StudentExamAreaFilterParams extends BaseFilters {
  examAreaId?: number[];
}

const baseUrl = 'student-exams';

export async function listStudentExams(params: StudentExamFilterParams = {}) {
  const { data } = await requester().get<JsonApiResponse<StudentExam>>(
    `${baseUrl}/`,
    {
      params,
    },
  );

  return data;
}

export async function getStudentExam(studentExamId: number) {
  const { data } = await requester().get<StudentExam>(
    `${baseUrl}/${studentExamId}/`,
  );

  return data;
}

export async function updateStudentExam(
  studentExamId: number,
  body: StudentExamCorrectionDTO,
) {
  const { data } = await requester().patch<StudentExam>(
    `${baseUrl}/${studentExamId}/`,
    body,
  );

  return data;
}

export async function publishStudentExam(
  studentExamId: number,
  body: StudentExamCorrectionDTO,
) {
  const { data } = await requester().post<StudentExam>(
    `${baseUrl}/${studentExamId}/publish/`,
    body,
  );

  return data;
}

export async function listStudentExamActivitiesProgress(
  studentExamId: number,
  params: StudentExamAreaFilterParams = {},
) {
  const { data } = await requester().get<
    JsonApiResponse<StudentExamActivityProgress>
  >(`${baseUrl}/${studentExamId}/activities-progress/`, { params });

  return data;
}

export async function listStudentExamCorrection(
  studentExamId: number,
  params: StudentExamAreaFilterParams = {},
) {
  const { data } = await requester().get<
    JsonApiResponse<StudentExamCorrection>
  >(`${baseUrl}/${studentExamId}/correction/`, { params });

  return data;
}
